/** @jsx jsx */
import { jsx, css, Global } from "@emotion/core";
import React from "react";
import { theme, ComponentsProvider } from "docz";
import WebFont from "webfontloader";
import Page from "./Page";

WebFont.load({
  google: {
    families: ["Montserrat"]
  }
});

const map = {
  page: Page,
  notFound: Page
};

function Theme({ children }) {
  return (
    <>
      <Global
        styles={css`
          *,
          *::before,
          *::after {
            box-sizing: border-box;
            margin: 0;
          }
          html,
          body {
            font-size: 16;
            padding: 0;
            margin: 0;
            width: 100%;
            height: 100%;
            font-family: Montserrat, “Helvetica Neue”, Arial, sans-serif;
          }
          h1 {
            font-size: 5.88rem;
          }
          h2 {
            font-size: 2.88rem;
          }
          h3 {
            font-size: 1.88rem;
          }
          ul {
            text-align: left;
            list-style-position: inside;
            padding: 0 0 0 35px;
          }
          li {
            font-size: 2.66rem;
            list-style-position: outside;
            padding-bottom: 25px;
          }
          li > ul > li {
            padding-top: 25px;
            padding-bottom: 0;
          }
          img {
            width: 100%;
          }
          a {
            color: inherit;
          }
        `}
      />
      <ComponentsProvider components={map}>{children}</ComponentsProvider>
    </>
  );
}

export default theme()(Theme);
